<template>
  <span>
    <span v-if="!editing" class="ml-2">
      <template v-if="!isUserOverride && isUserEditMode">
        <i class="fas fa-check fa-fw permission-allowed-inheritted" v-if="isTicked"> </i>
        <i class="fas fa-times fa-fw permission-denied-inheritted" v-if="isCrossed"> </i>
        <i class="fas fa-circle fa-fw permission-mixed" v-if="isMixed"> </i>
      </template>
      <template v-if="!isUserOverride && !isUserEditMode">
        <i class="fas fa-check fa-fw permission-allowed" v-if="isTicked"> </i>
        <i class="fas fa-ban fa-fw permission-denied" v-if="isCrossed"> </i>
        <i class="fas fa-circle fa-fw permission-mixed" v-if="isMixed"> </i>
      </template>
      <Tooltip v-if="isUserOverride" label="User permission has overridden the group permission" helpStyle>
        <i class="far fa-check-circle fa-fw permission-allowed permission-user-override" v-if="isTicked"> </i>
        <i class="fas fa-ban fa-fw permission-denied permission-user-override" v-if="isCrossed"> </i>
        <i class="fas fa-circle fa-fw permission-mixed permission-user-override" v-if="isMixed"> </i>
      </Tooltip>
    </span>
    
    <span v-if="editing">
      <FormPermissionSwitch :permKey="code + '.' + access" :value="switchValue" :inherited="inherited" @update="updateState" />
    </span>
  </span>
</template>

<style scoped>
.fa-check-circle.permission-user-override {
  font-size: 1.25rem;
}
.fa-ban.permission-user-override {
  font-size: 1.0rem;
}
</style>

<script>
import _ from 'lodash'
import { PermissionStateTypes } from '@/store/types'
import FormPermissionSwitch from '@/components/form/formPermissionSwitch.vue'

export default {
  name: "PermissionMatrixCell",
  components: {
    FormPermissionSwitch
  },
  props: {
    code: String,
    access: String,
    mapData: Object,
    editMode: String,
    editing: {
      type: Boolean,
      default: false
    },
    header: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      currentMapData: {}
    }
  },
  watch: {
    mapData: {
      immediate: true,
      handler: function (newVal, oldVal) {
        this.currentMapData = newVal
      },
      deep: true
    },
  },
  mounted() {
    
  },
  beforeDestroy() {
  },
  methods: {
    updateState(state) {
      var curMapData = this.currentMapData

      if(this.$props.editMode == 'user')
        curMapData.userState = state
      else
        curMapData.groupState = state

      var result = PermissionStateTypes.deny
      if(curMapData.groupState != PermissionStateTypes.inherit)
        result = curMapData.groupState
      if(curMapData.userState != PermissionStateTypes.inherit)
        result = curMapData.userState

      curMapData.result = result

      this.$emit('update', curMapData)
    }
  },
  computed: {
    switchValue() {
      if(this.currentMapData != null) {
        if(this.$props.editMode == 'user') {
          if(this.currentMapData.userState == PermissionStateTypes.inherit)
            return this.currentMapData.result
          return this.currentMapData.userState
        } else
          return this.currentMapData.groupState
      }
      return ''
    },
    isTicked() {
      if(this.currentMapData != null) {
        if(this.header) {
          if(this.$props.editMode == 'user')
            return this.currentMapData.userState == PermissionStateTypes.allow
          else
            return this.currentMapData.groupState == PermissionStateTypes.allow
        }

        return this.currentMapData.result == PermissionStateTypes.allow
      }
      return false
    },
    isCrossed() {
      if(this.currentMapData != null) {
        if(this.header) {
          if(this.$props.editMode == 'user')
            return this.currentMapData.userState == PermissionStateTypes.deny
          else
            return this.currentMapData.groupState == PermissionStateTypes.deny
        }
        return this.currentMapData.result == PermissionStateTypes.deny
      }
      return false
    },
    isMixed() {
      if(this.currentMapData != null) {
        if(this.header) {
          if(this.$props.editMode == 'user')
            return this.currentMapData.userState == PermissionStateTypes.mixed
          else
            return this.currentMapData.groupState == PermissionStateTypes.mixed
        }
        return this.currentMapData.result == PermissionStateTypes.mixed
      }
      return false
    },
    inherited() {
      if(this.$props.editMode == 'user')
        return this.currentMapData.userState == PermissionStateTypes.inherit
      return false
    },
    isUserEditMode() {
      return this.editMode == 'user'
    },
    isUserOverride() {
      if(this.editMode == 'user' && this.currentMapData.userState != PermissionStateTypes.inherit && !this.header)
        return true
      return false
    }
  }
};
</script>